/* eslint-disable class-methods-use-this */
import axios from "axios";

const CACHE_KEY = "bailo_ip_location";
const CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 horas

class ClientIpService {
  async getIpLocation() {
    // Usar cache si existe y no expiró
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_TTL_MS && data && data.city) {
          return data;
        }
      }
    } catch (_) { /* ignorar errores de parse */ }

    const { data } = await axios.get("https://ipapi.co/json/");

    // Solo cachear si la respuesta es válida (no error de rate limit)
    if (data && data.city && !data.error) {
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp: Date.now() }));
      } catch (_) { /* ignorar si localStorage está lleno */ }
    }

    return data;
  }
}

const commentService = new ClientIpService();

export default commentService;
